import "devextreme/dist/css/dx.light.css"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { useSelector } from "react-redux"
import { Routes, Route } from "react-router-dom"
import { layoutTypes } from "./constants/layout"

// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./App.css"
 
import Authenticate from "routes/Authenticate"
import NotFound from "pages/WrongUrl/NotFound"

import "devextreme/dist/css/dx.light.css" 
import FloatingBtn from "pages/Reports/FloatingBtn"
import { checkPermissionsByModule } from "utils/common-helpers"
import NotificationComponent from "utils/NotificationComponent"
import Help from "pages/WorkModule/Support/Help/Help"
import secureLocalStorage from "react-secure-storage" 
import axios from "axios"
import configure from "configure"

import "./assets/css/Work/support.css"

const getLayout = layoutType => {
  let Layout = VerticalLayout
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout
      break
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout
      break
    default:
      break
  }
  return Layout
}

const App = () => {
  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }))
  const Layout = getLayout(layoutType)
  const roles = useSelector(state => state?.Roles?.apiData)
  const permission = checkPermissionsByModule(roles, 96, 3)
  const isWft = secureLocalStorage.getItem('isWfh') == 1


    // restore users local values 
    useEffect(() => {
    if (localStorage.getItem("auth_id")) {
      (async () => {
        const response = await axios.get(
          `${configure.nodeApi
          }/allUsers/getLoggedInUserDetails/${localStorage.getItem("auth_id")}`
        )

        secureLocalStorage.setItem("auth_email", response.data.data.email)
        secureLocalStorage.setItem("auth_avt", response.data.data.avatar)
        secureLocalStorage.setItem("auth_name", response.data.data.name)
        secureLocalStorage.setItem("auth_role", response.data.data.roleid) 
        localStorage.setItem("auth_avt", response.data.data.avatar) 
      })()
    }
  }, [])


  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => {
          return (
            <>
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    <>
                      {route.module_id != undefined ? (
                        <Authenticate module={route.module_id} type={route.type}>
                          <Layout>{route.component}</Layout>
                        </Authenticate>
                      ) : (
                        <Layout>{route.component}</Layout>
                      )}

                      <Help /> 
                    </>
                  </Authmiddleware>
                }
                key={idx}
                exact={true}
              />

            </>
          )
        })}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {permission ? (
        <FloatingBtn />
      ) : null} 
      <NotificationComponent userId={localStorage.getItem('auth_id')} />
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
